<template>
  <div class="contenido">
    <div class="pdf-container">
      <div class="info-layout">

        <!-- Botonera + Switcher de idioma (panel izquierdo) -->
        <div class="botonera">
          <div class="lang-switch">
            <button :class="{ active: locale === 'es' }" @click="setLang('es')">ES</button>
            <span class="lang-sep">|</span>
            <button :class="{ active: locale === 'en' }" @click="setLang('en')">EN</button>
            <span v-if="translating" class="translating-msg">{{ $t('print.translating') }}</span>
          </div>

          <button class="action-button" @click="generarPDF">
            <span class="material-icons">download</span>
            {{ $t('print.download') }}
          </button>
          <button class="action-button secondary" @click="irAEncuesta">
            <span class="material-icons">rate_review</span>
            {{ $t('footer.survey') }}
          </button>
          <div v-if="qrEncuesta" class="qr-encuesta">
            <img :src="qrEncuesta" :alt="$t('footer.survey')">
            <span>{{ $t('survey.scan_qr') }}</span>
          </div>
          <button class="action-button secondary" @click="volverARegistro">
            <span class="material-icons">arrow_back</span>
            {{ $t('print.back') }}
          </button>
        </div>

        <!-- Contenido PDF -->
        <div v-if="consultaData" ref="pdfContent" class="pdf-content">
          <div class="encabezado">
            <div class="clinica-info">
              <h2>{{ $t('print.title') }}</h2>
              <p v-if="medicoInfo.nombre_completo"><strong>{{ $t('print.doctor') }}:</strong> {{ medicoInfo.nombre_completo }}</p>
              <p v-if="medicoInfo.cedula"><strong>{{ $t('print.license') }}:</strong> {{ medicoInfo.cedula }}</p>
            </div>
            <div class="fecha-folio">
              <img class="logo" src="@/assets/imagenes/logotipo.png" alt="Logo" />
              <p><strong>{{ $t('print.date') }}:</strong> {{ consultaData.fecha }}</p>
              <p><strong>{{ $t('print.folio') }}:</strong> {{ consultaData.folio }}</p>
            </div>
          </div>

          <table class="table">
            <thead>
              <tr><th colspan="2">{{ $t('print.patient') }}</th></tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>{{ $t('print.full_name') }}:</strong></td>
                <td>{{ nombreCompleto }}</td>
              </tr>
              <tr>
                <td><strong>{{ $t('print.age') }}:</strong></td>
                <td>{{ consultaData.edad }} {{ $t('print.years') }}</td>
              </tr>
              <tr>
                <td><strong>{{ $t('print.gender') }}:</strong></td>
                <td>{{ nr('genero') }}</td>
              </tr>
              <tr>
                <td><strong>{{ $t('print.phone') }}:</strong></td>
                <td>{{ nr('telefono') }}</td>
              </tr>
              <tr>
                <td><strong>{{ $t('print.country') }}:</strong></td>
                <td>{{ nr('pais') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table" v-if="tieneVitales">
            <thead>
              <tr><th colspan="4">{{ $t('print.vitals') }}</th></tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>{{ $t('print.bp') }}:</strong></td>
                <td>{{ nr('presion') }}</td>
                <td><strong>{{ $t('print.temp') }}:</strong></td>
                <td>{{ nr('temperatura', '°C') }}</td>
              </tr>
              <tr>
                <td><strong>{{ $t('print.hr') }}:</strong></td>
                <td>{{ nr('frecuencia', 'lpm') }}</td>
                <td><strong>{{ $t('print.spo2') }}:</strong></td>
                <td>{{ nr('saturacion', '%') }}</td>
              </tr>
              <tr>
                <td><strong>{{ $t('print.respiratory_rate') }}:</strong></td>
                <td colspan="3">{{ nr('frecuencia_respiratoria', 'rpm') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table" v-if="serviciosAdicionalesSeleccionados.length">
            <thead>
              <tr><th>{{ $t('print.additional_services') }}</th></tr>
            </thead>
            <tbody>
              <tr v-for="s in serviciosAdicionalesSeleccionados" :key="s.clave">
                <td>{{ s.concepto }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table">
            <thead>
              <tr><th>{{ $t('print.history') }}</th></tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p><strong>{{ $t('print.diseases') }}:</strong> {{ nr('enfermedades') }}</p>
                  <p><strong>{{ $t('print.allergies') }}:</strong> {{ nr('alergias') }}</p>
                  <p><strong>{{ $t('print.medication') }}:</strong> {{ nr('medicacion') }}</p>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table">
            <thead>
              <tr><th>{{ $t('print.diagnosis') }}</th></tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <template v-if="consultaData.sintomas">
                    <p><strong>{{ $t('print.symptoms') }}:</strong></p>
                    <p>{{ nr('sintomas') }}</p>
                  </template>
                  <p><strong>{{ $t('print.diagnosis_label') }}:</strong></p>
                  <p>{{ nr('diagnostico') }}</p>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table">
            <thead>
              <tr><th>{{ $t('print.observations') }}</th></tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ nr('observaciones') }}</td>
              </tr>
            </tbody>
          </table>
<table class="table medico-footer">
  <tbody>
    <tr>
      <td style="border: none; padding-top: 20px;">
        <div style="display: flex; justify-content: flex-end; align-items: flex-end; flex-wrap: wrap;">
          <div style="text-align: center;">
            <div v-if="medicoInfo.firma_archivo" style="margin-bottom: 4px;">
              <img :src="medicoInfo.firma_archivo" alt="Firma del médico" style="max-height: 50px; max-width: 180px; border-bottom: 1px solid #333;" />
            </div>
            <div v-else style="border-bottom: 1px solid #333; min-width: 120px; height: 30px;"></div>
            <span style="font-size: 12px; color: #555;">{{ $t('print.signature') }}</span>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>

          <p class="direccion-pie">{{ direccionReceta }}</p>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Swal from 'sweetalert2';
import DOMPurify from 'dompurify';
import QRCode from 'qrcode';
import { getConsultaByFolio, getDireccionReceta, SERVICIOS_ADICIONALES } from '@/utils/api';
import i18n from '@/i18n';

export default {
  name: 'InfoPacientes',
  data() {
    return {
      sidebarCerrado: false,
      consultaData: null,
      translatedData: null,
      translating: false,
      ocultarFirma: false,
      locale: localStorage.getItem('sanatia_lang') || 'es',
      // ✅ Nuevos datos
      medicoInfo: {},
      direccionReceta: '',
      qrEncuesta: '',
    };
  },
  computed: {
    displayData() {
      if (this.locale === 'en' && this.translatedData) return this.translatedData;
      return this.consultaData;
    },
    nombreCompleto() {
      if (!this.consultaData) return '';
      return `${this.consultaData.nombre || ''} ${this.consultaData.apellido_paterno || ''} ${this.consultaData.apellido_materno || ''}`.trim();
    },
    tieneVitales() {
      const c = this.consultaData;
      return !!(c && (c.presion || c.frecuencia || c.temperatura || c.saturacion || c.frecuencia_respiratoria));
    },
    serviciosAdicionalesSeleccionados() {
      const claves = this.consultaData?.servicios_adicionales || [];
      return SERVICIOS_ADICIONALES.filter(s => claves.includes(s.clave));
    },
  },
  async created() {
    const folioParam = this.$route.params.folio;
    this.cargarDatosPorFolio(folioParam);
    this.direccionReceta = await getDireccionReceta();
    this.generarQrEncuesta();
  },
  methods: {
    async generarQrEncuesta() {
      try {
        const url = `${window.location.origin}/encuesta`;
        this.qrEncuesta = await QRCode.toDataURL(url, { width: 140, margin: 1 });
      } catch {
        this.qrEncuesta = '';
      }
    },

    setLang(lang) {
      this.locale = lang;
      localStorage.setItem('sanatia_lang', lang);
      i18n.global.locale.value = lang;
      if (lang === 'en' && !this.translatedData && this.consultaData) {
        this.translateConsulta();
      }
    },

    nr(campo, unidad = '') {
      const v = this.displayData?.[campo];
      if (!v && v !== 0) return this.$t('print.not_registered');
      return unidad ? `${v} ${unidad}` : String(v);
    },

    async translateText(text) {
      try {
        const res = await fetch(
          `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=es|en`
        );
        const data = await res.json();
        return data.responseData?.translatedText || text;
      } catch {
        return text;
      }
    },

    async translateConsulta() {
      if (!this.consultaData) return;
      this.translating = true;
      const fields = ['genero', 'pais', 'enfermedades', 'alergias', 'medicacion', 'sintomas', 'diagnostico', 'observaciones'];
      const translated = { ...this.consultaData };
      for (const field of fields) {
        const val = this.consultaData[field];
        if (val) translated[field] = await this.translateText(val);
      }
      this.translatedData = translated;
      this.translating = false;
    },

    async cargarDatosPorFolio(folio) {
      const limpio = Array.from(DOMPurify.sanitize(String(folio || '')))
        .filter(c => c.charCodeAt(0) > 0x1F && c.charCodeAt(0) !== 0x7F)
        .join('')
        .trim();

      if (!limpio || limpio.length > 50) {
        Swal.fire('Error', 'Folio inválido.', 'error');
        this.$router.push('/busqueda');
        return;
      }

      const consulta = await getConsultaByFolio(limpio);
      if (consulta) {
        this.consultaData = { ...consulta };
        this.medicoInfo = consulta.doctor_nombre_completo ? {
          nombre_completo: consulta.doctor_nombre_completo,
          cedula: consulta.doctor_cedula || '—',
          firma_archivo: consulta.doctor_firma_archivo || null,
        } : {};
        if (this.locale === 'en') {
          this.translateConsulta();
        }
      } else {
        Swal.fire('Error', 'No se encontró el folio', 'error');
        this.$router.push('/busqueda');
      }
    },

    async generarPDF() {
      const pdfContent = this.$refs.pdfContent;
      if (!pdfContent) return;

      const canvas = await html2canvas(pdfContent, {
        scale: 2,
        useCORS: true,
        logging: false
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'letter'
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pageWidth - 20;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (imgHeight > pageHeight - 20) {
        const scaleFactor = (pageHeight - 20) / imgHeight;
        const finalWidth = imgWidth * scaleFactor;
        const finalHeight = imgHeight * scaleFactor;
        pdf.addImage(imgData, 'PNG', (pageWidth - finalWidth) / 2, 10, finalWidth, finalHeight);
      } else {
        pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
      }

      pdf.save(`consulta_${this.consultaData.folio}.pdf`);
    },

    volverARegistro() {
      this.$router.push('/');
    },

    irAEncuesta() {
      this.$router.push('/encuesta');
    },
  },
};
</script>

<style scoped>
/* ---------- LANG SWITCH ---------- */
.lang-switch {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
}

.lang-switch button {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #aaa;
  padding: 4px 2px;
  transition: color 0.15s;
}

.lang-switch button.active {
  color: var(--brand-primary);
}

.lang-switch button:hover {
  color: var(--brand-primary);
}

.lang-sep {
  color: #ccc;
  font-size: 12px;
  user-select: none;
}

.translating-msg {
  margin-left: 6px;
  font-size: 12px;
  color: var(--brand-primary);
  font-style: italic;
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.4; }
}

/* ---------- CONTENIDO PRINCIPAL ---------- */
.contenido {
  padding: 20px;
  transition: margin-left 0.3s ease;
  background-color: var(--brand-beige);
  min-height: 100vh;
}

.contenido-expandido {
  margin-left: 250px;
}

/* ---------- CONTENEDOR DEL PDF ---------- */
.pdf-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* ---------- LAYOUT FLEX (Botones izq + PDF der) ---------- */
.info-layout {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

@media (min-width: 768px) {
  .info-layout {
    flex-direction: row;
    align-items: flex-start;
  }
}

/* ---------- TARJETA DEL PDF ---------- */
.pdf-content {
  background-color: var(--white);
  padding: 20px 25px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(19, 62, 104, 0.12);
  flex: 2;
  transition: box-shadow 0.3s ease;
}

.pdf-content:hover {
  box-shadow: 0 10px 30px rgba(19, 62, 104, 0.18);
}

/* ---------- ENCABEZADO DEL PDF ---------- */
.encabezado {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid var(--brand-secondary-light);
}

.logo {
  width: 100%;
  max-width: 180px;
  height: auto;
  margin-top: 10%;
  display: block;
}

.clinica-info h2 {
  margin: 0 0 6px 0;
  color: var(--brand-primary);
  font-weight: 700;
  font-size: 22px;
  letter-spacing: -0.3px;
}

.clinica-info p {
  margin: 4px 0;
  font-size: 14px;
  color: var(--brand-secondary);
  font-weight: 500;
}

.fecha-folio {
  text-align: right;
  min-width: 120px;
}

.fecha-folio p {
  margin: 4px 0;
  font-size: 14px;
  color: var(--brand-secondary);
  font-weight: 500;
}

/* ---------- TABLAS ---------- */
.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  font-size: 14px;
}

.table th {
  background-color: var(--brand-primary);
  color: var(--white);
  padding: 12px 15px;
  text-align: left;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

.table td {
  padding: 12px 15px;
  border: 1px solid var(--brand-secondary-light);
  color: var(--brand-secondary);
  font-weight: 500;
}

.table tbody tr:nth-child(even) {
  background-color: #f9f8f7;
}

.table tbody tr:hover {
  background-color: var(--brand-beige);
  transition: background-color 0.2s ease;
}

/* ---------- BOTONERA ---------- */
.botonera {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
  justify-content: flex-start;
  align-items: stretch;
}

@media (min-width: 768px) {
  .botonera {
    margin-top: 0;
    margin-right: 0;
  }
}

/* ---------- BOTONES ---------- */
.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 24px;
  background-color: var(--brand-accent-sage);
  color: var(--white);
  font-weight: 700;
  font-size: 15px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(96, 127, 112, 0.25);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: 100%;
}

.action-button:hover {
  background-color: var(--brand-accent-navy);
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(48, 80, 101, 0.35);
}

.action-button:active {
  transform: scale(0.96);
}

.action-button.secondary {
  background-color: var(--brand-secondary-light);
  box-shadow: 0 4px 10px rgba(153, 153, 153, 0.25);
}

.action-button.secondary:hover {
  background-color: var(--brand-secondary);
  box-shadow: 0 6px 16px rgba(87, 87, 86, 0.3);
}

.action-button.editar {
  background-color: var(--brand-primary);
}

.action-button.editar:hover {
  background-color: var(--brand-accent-navy);
}

.action-button .material-icons {
  font-size: 22px;
}

.qr-encuesta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 12px;
  background: var(--white);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.qr-encuesta img {
  width: 120px;
  height: 120px;
}

.qr-encuesta span {
  font-size: 12px;
  color: var(--brand-secondary);
  text-align: center;
}

.action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* --- Modo edición (paciente editando su propio expediente) --- */
.editando-tag {
  font-weight: 400;
  text-transform: none;
  opacity: 0.8;
}

.edit-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}

.edit-input-sm,
.edit-input-full,
.edit-grid-3 input,
.edit-textarea {
  width: 100%;
  padding: 7px 10px;
  border: 2px solid var(--brand-secondary-light);
  border-radius: 6px;
  font-size: 13px;
  color: var(--brand-secondary);
  box-sizing: border-box;
  font-family: inherit;
}

.edit-input-full { margin-bottom: 8px; }

.edit-textarea {
  resize: vertical;
  margin-bottom: 8px;
}

.edit-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--brand-secondary-light);
  margin-bottom: 4px;
}

.direccion-pie {
  margin: 16px 0 0;
  text-align: center;
  font-size: 11px;
  color: var(--brand-secondary);
  opacity: 0.55;
}

/* ---------- RESPONSIVE ---------- */
@media (max-width: 1024px) {
  .contenido { padding: 15px; }
  .pdf-container { padding: 15px; }
}

@media (max-width: 768px) {
  .contenido { padding: 10px; }
  .contenido-expandido { margin-left: 0 !important; }
  .pdf-container { padding: 10px; }
  .info-layout { flex-direction: column; gap: 15px; }
  .pdf-content { padding: 16px 18px; flex: none; }
  .botonera { flex: none; align-items: stretch; }
  .action-button { padding: 12px 20px; font-size: 14px; }
  .action-button .material-icons { font-size: 20px; }
  .encabezado { flex-direction: column; align-items: center; text-align: center; gap: 15px; }
  .logo { width: 60%; max-width: 140px; margin-top: 5%; }
  .clinica-info h2 { font-size: 20px; }
  .fecha-folio { text-align: center; }
  .table th, .table td { padding: 8px 10px; font-size: 13px; }
}

@media (max-width: 480px) {
  .pdf-content { padding: 12px 14px; }
  .table th, .table td { font-size: 12px; padding: 6px 8px; }
  .clinica-info h2 { font-size: 18px; }
  .clinica-info p, .fecha-folio p { font-size: 12px; }
  .action-button { font-size: 13px; padding: 10px 16px; }
  .action-button .material-icons { font-size: 18px; }
  .logo { width: 50%; max-width: 100px; }
}

/* ---------- IMPRESIÓN ---------- */
@media print {
  .botonera, .action-button, .lang-switch { display: none !important; }

  body { margin: 0; padding: 10px; font-size: 12px; line-height: 1.2; background: white; }
  .contenido { margin: 0 !important; padding: 0 !important; background-color: white !important; }
  .contenido-expandido { margin-left: 0 !important; }
  .pdf-container { max-width: 100%; padding: 0; margin: 0; }
  .info-layout { display: block !important; }
  .pdf-content { width: 100%; max-width: 7.5in; margin: 0 auto; padding: 0.3in; box-shadow: none !important; border-radius: 0; background: white; flex: none; }
  .encabezado { border-bottom-color: #999999; margin-bottom: 15px; padding-bottom: 10px; }
  .clinica-info h2 { color: #133E68 !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
  .clinica-info p, .fecha-folio p { color: #575756 !important; }
  .table th { background-color: #133E68 !important; color: white !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
  .table td { border-color: #999999 !important; color: #575756 !important; }
  .table tbody tr:nth-child(even) { background-color: #f9f8f7 !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
  .logo { max-width: 120px; }

  @page { margin: 0.5in; size: letter; }
}
</style>
